import { ITimeEntry } from '../../queries/TimeEntry';

export const ALL = 'all';

export interface IReviewFilters {
	rep: string;
	office: string;
}

export function matchesReviewFilters(entry: ITimeEntry, { rep, office }: IReviewFilters) {
	return (rep === ALL || entry.userId === rep) && (office === ALL || entry.officeLocation === office);
}

export function distinctOffices(entries: ITimeEntry[]) {
	return [...new Set(entries.map(entry => entry.officeLocation).filter((office): office is string => !!office))].sort();
}

export function distinctUserIds(entries: ITimeEntry[]) {
	return [...new Set(entries.map(entry => entry.userId))];
}

export const OVER_SPAN_WARNING_MINUTES = 15;
